// import {
//   CHANGE_SIDEBAR_VISIBILITY,
//   CHANGE_MOBILE_SIDEBAR_VISIBILITY
// } from '../actions/sidebarActions';


export const CHANGE_SIDEBAR_VISIBILITY = 'CHANGE_SIDEBAR_VISIBILITY';
export const CHANGE_MOBILE_SIDEBAR_VISIBILITY = 'CHANGE_MOBILE_SIDEBAR_VISIBILITY';

//reducer
const initialState = {
  show: false,
  collapse: false
};

export function sidebarReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_SIDEBAR_VISIBILITY:
      return {...state, collapse: !state.collapse};
    case CHANGE_MOBILE_SIDEBAR_VISIBILITY:
      return {...state, show: !state.show};
    default:
      return state;
  }
}

//action
export function changeSidebarVisibility() {
  return {
    type: CHANGE_SIDEBAR_VISIBILITY
  };
}

export function changeMobileSidebarVisibility() {
  return {
    type: CHANGE_MOBILE_SIDEBAR_VISIBILITY
  };
}



// WEBPACK FOOTER //
// ./src/redux/SideBar.js